/**
 * 删除素材组
 */

import { Modal } from 'antd';
import React from 'react';
interface IDeleteGroupProps {
  visible: boolean;
  onCancel: () => void;
  handleOk: () => void;
}

const DeleteGroup = (props: IDeleteGroupProps) => {
  const { visible, onCancel, handleOk } = props;
  return (
    <Modal title="删除确认操作" visible={visible} onOk={handleOk} onCancel={onCancel}>
      <div>
        <span style={{ color: 'red', textAlign: 'center', display: 'block', margin: '10px 0' }}>
          是否确认对该素材组进行“删除”
        </span>
        <p>
          注：“删除”后的素材组将被冻结，且无法在列表页查看。
          若需再次使用该素材组，请至素材管理-自定义素材-归档素材库中对素材组进行复原
        </p>
      </div>
    </Modal>
  );
};

export default DeleteGroup;
